import {CheckoutItemsValidator} from "../checkoutItemsValidator";

export class CheckoutItemsPayyoValidator extends CheckoutItemsValidator
{
    validateCartData(params = {}) {
        super.validateCartData(params);
        // console.log(params);
    }
}
